export function initLoadMore() {
  var page = 2;

  const loadMoreButton = document.querySelector(".aktuelles-load-more");
  const postContainer = document.querySelector(".aktuelles__query ul");

  loadMoreButton.addEventListener("click", function () {
    var currentCategoryLink = document.querySelector(".current-cat a");
    if (currentCategoryLink) {
      var currentCategory = currentCategoryLink.textContent.trim();
      loadPosts(currentCategory);
    } else {
      loadPosts("");
    }

    loadMoreButton.disabled = true;

    function loadPosts(category) {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", "/wp-admin/admin-ajax.php", true);
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            console.log(response);

            if (response.html.length > 0) {
              response.html.forEach(function (post) {
                var li = document.createElement("li");
                li.className = "wp-block-post";
                li.innerHTML = `
                    <h2 class="card__heading wp-block-post-title">
                      <a href="${post.link}">${post.title}</a>
                    </h2>
                    <figure class="card__featured-image wp-block-post-featured-image">
                    <a href="${post.link}"><img src="${post.image}" alt="${post.title}"></a>
                    </figure>
                    <div class="taxonomy-category card__categories wp-block-post-terms">
                      <a href="${post.site_url}/aktuelles/${post.category[0].slug}" rel="tag">${post.category[0].name}</a>
                    </div>
                    <div class="card__post-date wp-block-post-date">
                    <a href="${post.link}">${post.date}</a>
                    </div>
                    <div class="card__content wp-block-post-excerpt">
                    <p class="wp-block-post-excerpt__excerpt">${post.excerpt}</p>
                    </div>
                    <a class="card__button wp-block-read-more" href="${post.link}">Mehr lesen</a>
                  `;
                postContainer.appendChild(li);
              });
            }

            if (page < response.max) {
              loadMoreButton.disabled = false;
              page++;
            } else {
              loadMoreButton.style.display = "none";
            }
          } else {
            console.error("Request failed: " + xhr.status);
          }
        }
      };

      xhr.send(
        "action=fvms_load_more&paged=" +
          page +
          "&category=" +
          encodeURIComponent(category)
      );
    }
  });
}
